<template>
    <div class="selectable-wrapper not-checkable" v-bind:class="{'checked': checked}">
        <div class="icon-wrapper">
            <div class="flex-content">
                <div class="width-100 relative text-center">
                    <slot name="icon"></slot>
                </div>
            </div>
        </div>
        <div class="text-wrapper">
            <div class="flex-content">
                <div class="relative width-100">
                 <div class="title-text"><slot name="title-text"></slot></div>
                 <div class="label-text"><slot name="label-text"></slot></div>
                </div>
            </div>
        </div>
        <div class="checkbox-wrapper">
            <div class="flex-content">
                <div class="width-100 relative">
                    <Input type="checkbox" :checked="checked" width="inline" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Input from "../../components/Input/Input";

    export default {
        name: 'Selectable',
        components: {
            Input
        },
        props: ["checked"],
        data () {
            return {
            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./Selectable.scss" scoped lang="scss"></style>

